<div class="showOnPrint print-filters" *ngIf="filters?.length">
	<h4 class="print-filters-title" *ngIf="title">{{ title | translate }}</h4>
	<table class="print-filters-table">
		<thead>
			<tr>
				<th *ngFor="let filter of filters">{{ filter.label | translate }}</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td *ngFor="let filter of filters">{{ filter.value }}</td>
			</tr>
		</tbody>
	</table>
</div>
